<template>
  <div>
    <page-header title="Priority Queue" ></page-header>
    <b-container>
      <b-table :items="filteredMembers" hover :fields="fields" primary-key="id" v-if="filteredMembers && filteredMembers.length">
        <template v-slot:cell(name)="data">
          <span v-router-link="{name:'MemberDetail',params:{id:data.item.id}}">{{data.item.name}}</span>
        </template>
      </b-table>
      <div v-else class="inbox-zero">
        <img class="mb-5" :src="winning">
        <h3>There's no one to call</h3>
        <p>Work on the <a href="#/backlog">backlog</a>, maybe?</p>
      </div>
    </b-container>
  </div>
</template>
<script>
import { ListRecentMembers, ListRecentMembersSubscription } from '@/gql/members/ListRecentMembers.gql';
import PageHeader from '@/components/global/PageHeader';

export default {
  components: {
    PageHeader,
  },
  data (){
    const now = new Date();
    return {
      since: new Date(now.getTime() - 1000 * 60 * 60),
      fields: [
        'name',
        {
          key: 'createdAt',
          label: 'Joined',
          formatter: value => {
            return this.$moment(value).fromNow()
          }
        },
        {
          key: 'timezone',
          label: 'Local Time',
          formatter: value => {
            return this.$moment.tz(value).format('HH:mm')
          }
        },
        {
          key: 'location',
          label: 'Location',
          formatter: value => {
            return value ? `${value.city}, ${value.country_name}` : '';
          }
        },
        {
          key: 'completedAt',
          label: 'Registration',
          formatter: value => {
            return value ? 'Completed' : 'In Progress';
          }
        },
        'score'
      ]
    };
  },
  computed: {
    filteredMembers() {
      if (this.members) {
        return this.members.filter((member) => (!member.recentCalls.length)).map(m => {
          const elapsed = Date.now() - (new Date(m.createdAt).getTime());
          m._rowVariant = (!!m.completedAt  || (elapsed > 1000 * 60 * 10)) ? 'success' : 'light';
          return m;
        });
      }
    },
    winning() {
      return 'https://picsum.photos/800/300';
    }
  },
  apollo: {
    members: {
      query: ListRecentMembers,
      variables() {
        return {
          since: this.since,
        }
      },
      subscribeToMore: {
        document: ListRecentMembersSubscription,
        variables() {
          return {
            since: this.since,
          };
        },
        updateQuery(previousResult, { subscriptionData }) {
          // console.log('Update', previousResult);
          // console.log('SD', subscriptionData);
        }
      }
    },
  },
};
</script>
<style scoped>
  .inbox-zero
  {
    border: dashed 3px #efefef;
    padding:20px;
    text-align:center;
  }
  .inbox-zero img
  {
    width:800px;
    height:300px;
  }
</style>
